import { PhotoActionHandlers } from '../../PhotoActions/PhotoActionHandlers'
import { useUsername } from '@jotta/grpc-connect-client/customer'
import { useNavigate } from 'react-router-dom'
import type { AlbumInfoStore } from '../../../store/AlbumInfoStore'
import { observer } from 'mobx-react-lite'

export const AlbumActionHandlers = observer<{
  store: AlbumInfoStore
}>(function AlbumActionHandlers({ store }) {
  const album = store.model
  const navigate = useNavigate()
  const username = useUsername()

  return (
    <div className="flex justify-end gap-2">
      <PhotoActionHandlers
        actionContext={store.viewContexts.album}
        album={album}
        albumId={album.id}
        getDownloadInfo={store.getDownloadInfo}
        isAlbumSubscriber={store.isSubscriber}
        isAlbumUser={store.isAlbumUser}
        photoIds={store.selectedPhotoIds}
        readOnly={!album.canAddPhotos}
        shareId={album.shareInfo?.uri}
        shareLink={store.shareLink}
        username={username}
        onDispatch={(actionType, ...args) => {
          switch (actionType) {
            case 'FOLLOW_ALBUM':
              return false
          }
        }}
        onDispatchComplete={(actionType, ...args) => {
          switch (actionType) {
            case 'LEAVE_ALBUM':
              navigate('../')
              break

            default:
              break
          }
        }}
      />
    </div>
  )
})
